import { render, staticRenderFns } from "./pc-image-preview.vue?vue&type=template&id=33e9f0e2&scoped=true&"
import script from "./pc-image-preview.vue?vue&type=script&lang=ts&"
export * from "./pc-image-preview.vue?vue&type=script&lang=ts&"
import style0 from "./pc-image-preview.vue?vue&type=style&index=0&id=33e9f0e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e9f0e2",
  null
  
)

export default component.exports